/**
 * Account vocabulary — FR-026, FR-038, FR-066, FR-075.
 */
/**
 * FR-038, FR-061. The role is granted by an administrator who already holds
 * it (PATCH /api/admin/users/:id/role), or, for the first one, by the
 * bootstrap CLI. It is never settable by the account it belongs to: no
 * sign-up and no profile update writes 'admin'.
 */
export const USER_ROLES = ['learner', 'admin'];
/**
 * FR-066, FR-075. Locale selects the notation note names are presented in and
 * nothing else — no recorded attempt, completion, session, history, or
 * Exercise configuration varies by locale.
 */
export const SUPPORTED_LOCALES = ['pt-BR', 'en'];
/** The default for this release (FR-066). */
export const DEFAULT_LOCALE = 'pt-BR';
/**
 * Who may read a learner's figures on their profile.
 *
 * `public` is the open page: name, picture, lifetime points, this week's,
 * podiums, streaks and the two follow counts, to anyone signed in. `private`
 * narrows that to the name and the picture — the two things a follow request,
 * an invite link and a ranking row already carry — and keeps the rest for the
 * learner themselves.
 *
 * IT IS ABOUT THE PROFILE, NOT ABOUT THE WEEK. The board is one week's record
 * of everyone who practised, cut once for everybody, and a private learner
 * still appears on it by name; what privacy withholds is the page behind that
 * name. Saying so is the whole reason the setting is named for the profile.
 */
export const PROFILE_VISIBILITIES = ['public', 'private'];
/** A profile is open until its owner says otherwise. */
export const DEFAULT_PROFILE_VISIBILITY = 'public';
/**
 * How long a display name may be.
 *
 * The lower bound is a single character, because a name somebody chose is
 * theirs to choose; the upper one is the width a ranking row, a follow list
 * and an avatar caption can all carry without truncating into a mystery.
 */
export const NAME_MIN_LENGTH = 1;
export const NAME_MAX_LENGTH = 60;
export function isUserRole(value) {
    return typeof value === 'string' && USER_ROLES.includes(value);
}
export function isSupportedLocale(value) {
    return typeof value === 'string' && SUPPORTED_LOCALES.includes(value);
}
export function isProfileVisibility(value) {
    return typeof value === 'string' && PROFILE_VISIBILITIES.includes(value);
}
//# sourceMappingURL=accounts.js.map